import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function CategoryCard({ category }) {
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [imageSize, setImageSize] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*12);
        setLineHeight((zoomSize/100)*24);
        setImageSize((zoomSize/100)*52);
    }, [zoomSize]);

    return (
        <div className="px-1 flex flex-col items-center gap-1 shrink-0">
            <div style={{ width: `${imageSize}px`, height: `${imageSize}px` }} className="rounded-full overflow-hidden">
                <img className='size-full object-cover' src={category?.imageLink} alt={category.name} />
            </div>

            <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='font-normal text-[#212121] line-clamp-1'>{category.name}</p>
        </div>
    );
}

function CategorySection({ item }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [sectionGap, setSectionGap] = useState(0);
    const [boxGap, setBoxGap] = useState(0);
    const [paddingSide, setPaddingSide] = useState(0);

    useEffect(() => {
        setTextSize((zoomSize/100)*18);
        setLineHeight((zoomSize/100)*30);
        setSectionGap((zoomSize/100)*12);
        setBoxGap((zoomSize/100)*8);
        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div 
            style={{ gap: `${sectionGap}px` }} 
            className="w-full flex flex-col relative"
        >
            <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} className='font-medium text-[#212121]'>{item.item.name}</p>

            <div style={{ gap: `${boxGap}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} className="grid grid-cols-5">
                {item.item.categoryLinkList.map(category => {
                    return (
                        <CategoryCard 
                            key={category.id} 
                            category={category} 
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default CategorySection;
